<template>
  <div class="page-container">
    <Header :pageName="$route.name" />
    <div class="page-element">
      <div class="video-grid">
        <div class="videoContainer">
          <iframe width="560" height="315" src="https://www.youtube-nocookie.com/embed/DQhpeGP97pM?si=mwJSEgYT_VHvy4li" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        </div>
        <div>
          <h2 class="titles">Abduction (Starship Delta Part 2)
            <button class="header-button" @click="$router.push('/3D')">Go to 3D Page</button>
          </h2>
          <div class="boxContainer">
            <div class="infoBox">
              <h3 class="subtitle">Story & Plot</h3>
              <p class="desc">After receiving their mission, the spaceship travels to Earth. This VFX video showcases a 3D element integrated into the real-world environment, highlighting the abduction process. The protagonist is substituted with a 3D object to create the illusion of being abducted into the spaceship.</p>
            </div>
            <div class="infoBox">
              <h3 class="subtitle">Techniques & Process</h3>
              <p class="desc">The background was tracked in Blender to integrate the 3D elements seamlessly. Afterward, the elements were moved to After Effects to add effects such as the ring of warped-space created when the spaceship enters the atmosphere. The integration of 3D elements with real-world footage was meticulously handled to ensure realism.</p>
            </div>
            <div class="infoBox">
              <h3 class="subtitle">Sound Design</h3>
              <p class="desc">Premiere Pro was used for sound design, adding elements like spaceship sounds, sirens, and distant chaos to enhance the atmosphere. The sound design aimed to create an immersive experience, complementing the visual effects and reinforcing the narrative of the abduction.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="page-element">
      <div class="video-grid">
        <div>
          <h2 class="titles">Multilayers</h2>
          <p class="desc">This is a video where we tested adding Multilayers of videos in one creating this effects of object appearing and disappearing from the scene or even changing places and appearing in different place.</p>
        </div>
        <div class="videoContainer">
          <iframe width="560" height="315" src="https://www.youtube-nocookie.com/embed/xmo2iBcF5zo?si=nQi51rvO_v8Fk41u" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        </div>
      </div>
    </div>
    <div class="page-element">
      <div class="video-grid">
        <div class="videoContainer">
          <iframe width="560" height="315" src="https://www.youtube-nocookie.com/embed/BTzA3Q2VdI0?si=CsB5m79TBD1Z0D_irel=0&modestbranding=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        </div>
        <div>
          <h2 class="titles">Cool Transitions</h2>
          <p class="desc">This experimental video is all about transitions. I staged a video game fight sequence with live actors, using clever cuts and seamless transitions to mimic the flow of a player choosing characters, settings, and weapons in a game. It’s a dynamic piece demonstrating creative editing techniques.</p>
        </div>
      </div>
    </div>
    <div class="page-element">
      <div class="video-grid">
        <div>
          <h2 class="titles">Locke</h2>
          <p class="desc">In this fully self-produced short, we handled every aspect of production—from acting and directing to sound design and set creation. <br> This clip is an exercise in recreating a scene from the movie Loke. I wanted to display our ability to capture a complex scene, focusing on camera movement, acting, and shot composition, maintaining the essence of the original movie.</p>
        </div>
        <div class="videoContainer">
          <iframe width="560" height="315" src="https://www.youtube.com/embed/Lp4RiBssrxI?si=jzlJ6ZPDtgORvwaf" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        </div>
      </div>
    </div>
    <div class="page-element">
      <div class="video-grid">
        <div class="videoContainer">
          <iframe width="560" height="315" src="https://www.youtube.com/embed/ee8kDkOEonc?si=YRRoQCRiuoLqoUcl" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        </div>
        <div>
          <h2 class="titles">Shot Scene of the exercise Loke (Previous video)</h2>
          <p class="desc">This is the scene that we recreated in the "Loke" exercise. (Just for reference)</p>
        </div>
      </div>
    </div>
    <div class="page-element">
      <div class="video-grid">
        <div>
          <h2 class="titles">Sound design for the movie Killing them softly</h2>
          <p class="desc">This project focuses on sound design. I took a scene from Killing Them Softly and completely reimagined its audio. By muting the original track, I created my own soundscape, layering custom effects and music to enhance the scene’s atmosphere.</p>
        </div>
        <div class="videoContainer">
          <iframe width="560" height="315" src="https://www.youtube.com/embed/XWdRGISf-Rw?si=LYtGUXFuxoh8djLN" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        </div>
      </div>
    </div>
    <div class="page-element">
      <div class="video-grid">
        <div class="videoContainer">
          <iframe width="560" height="315" src="https://www.youtube.com/embed/PhJtDMkJ_cI?si=eL1MlacsdTZ78Riu" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        </div>
        <div>
          <h2 class="titles">Scent Sender</h2>
          <p class="desc">In this conceptual ad for a fictional app, a father shares a scent memory with his daughter, who is far away and feeling nostalgic. The app allows him to send her the scent of his homemade soup, triggering memories of home. It’s a heartfelt story that plays with the futuristic concept of scent-sharing through technology.</p>
        </div>
      </div>
    </div>
    <div class="page-element">
      <div class="video-grid">
        <div>
          <h2 class="titles">Florin Lica Interview of Ansgard</h2>
          <p class="desc">In this interview, we crafted both the questions and responses to simulate a real conversation. This project was part of our camera operation class exercise, where we conducted a real interview with a person. From setting up the interview environment to managing camera angles and sound, we aimed to create a professional and engaging interview experience. This exercise allowed us to experiment with various aspects of interview production, including lighting, framing, and audio quality, to ensure a high-quality final product. Through this project, we gained valuable hands-on experience in the art of interview production and enhanced our technical skills in camera operation.</p>
        </div>
        <div class="videoContainer">
          <iframe width="560" height="315" src="https://www.youtube.com/embed/23oO6UJmOJs?si=Gg_gkz9vQYus0eSc" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        </div>
      </div>
    </div>
    <div class="page-element">
      <div class="video-grid">
        <div class="videoContainer">
          <iframe width="560" height="315" src="https://www.youtube.com/embed/-JS-mB3ffOM?si=vK-PXc2gqQdRPvfo" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        </div>
        <div>
          <h2 class="titles">Continuity</h2>
          <p class="desc">This short film is a creative exploration of continuity. Using only one camera, we filmed multiple perspectives to give the illusion of a multi-camera setup. This allowed us to create a more dynamic narrative, seamlessly transitioning between angles to tell a cohesive story.</p>
        </div>
      </div>
    </div>
    <div class="page-element">
      <div class="video-grid">
        <div>
          <h2 class="titles">Stop Motion</h2>
          <p class="desc">In this playful stop-motion video, we brought dolls to life by capturing a series of images. The dolls perform a charming dance on a table, creating a quirky and fun story through carefully timed movements. The result is a unique animation showcasing the magic of stop-motion techniques.</p>
        </div>
        <div class="videoContainer">
          <iframe width="560" height="315" src="https://www.youtube.com/embed/nt_D149g708?si=HMDghGZidLVwVUU6" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        </div>
      </div>
    </div>
    <div class="page-element">
      <div class="video-grid">
        <div class="videoContainer">
          <iframe width="560" height="315" src="https://www.youtube.com/embed/-aM22alyHKI?si=t25yDBo4FvzutlQb" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        </div>
        <div>
          <h2 class="titles">End Of The F* World - Florin Lica Trailer</h2>
          <p class="desc">This trailer was a personal challenge where I re-edited the first episode of the Netflix series "End of the F* World." My aim was to condense the episode into an engaging trailer that captured the essence of the story while focusing on timing and tension.</p>
        </div>
      </div>
    </div>
    <SiteFooter />
  </div>
</template>

<script>
import Header from './header.vue';
import SiteFooter from '@/components/SiteFooter.vue';
export default {
  name: 'VideoPage',
  components: {
    SiteFooter,
    Header
  }
}
</script>

<style scoped>
.page-container {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    height: 100vh;
    overflow-y: auto;
}

.page-element {
    border-radius: 20px;
    background: var(--gray);
    box-shadow: 0px 10px 0px 0px var(--DarkGray, #8494A7);
    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-direction: column;
    width: 90%;
    padding: 0 60px;
    margin: 30px 0;
}

.video-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
    width: 100%;
}

.titles {
    color: var(--Black);
    font-family: "Times New Roman";
    font-size: 32px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.desc {
    color: var(--Black, #26091C);
    font-family: "PT Sans Narrow";
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    width: 100%;
}

.videoContainer {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 100%;
    height: 100%;
    margin: 10px 0 60px 0;
}

.header-button {
    background-color: var(--primary-color);
    color: white;
    border: none;
    padding: 10px 20px;
    cursor: pointer;
    font-size: 16px;
    border-radius: 5px;
    margin-left: 10px;
}

@media (max-width: 768px) {
    .page-container {
        padding: 10px;
    }

    .titles {
        font-size: 1.5em;
        flex-direction: column;
        align-items: flex-start;
    }

    .video-grid {
        grid-template-columns: 1fr;
        gap: 10px;
    }

    .desc {
        width: 100%;
        font-size: 14px;
        padding: 0 10px;
        box-sizing: border-box;
    }

    .page-element {
        padding: 10px;
    }

    .videoContainer iframe {
        width: 100%;
        height: auto;
    }

    .header-button {
        margin-left: 0;
        margin-top: 10px;
    }
}
</style>
